import { useCallback, useState } from 'react'

export const useModalOpen = (isOpenInitial?: boolean) => {
  const [isOpen, setIsOpen] = useState(!!isOpenInitial)

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return { isOpen, open, close }
}
